<template>
  <div v-if="processing"
       class="inline-flex w-full justify-center">
    <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
    <span class="pl-4">Processing</span>
  </div>
  <div v-else class="w-full justify-center">
    <div class="text-lg leading-6 font-medium text-gray-900 pb-2" id="modal-headline">
      <slot name="title-content">
        {{ getActionText() }}
      </slot>
    </div>
    <div>
      <label for="comment" class="block text-sm font-medium text-gray-700">Add any notes or comments to be included with the signature below.</label>
      <div class="mt-1">
                    <textarea
                        v-model="notesText"
                        @input="$emit('update:modelValue', $event.target.value)"
                        rows="4" id="comment" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      </div>
    </div>
    <div class = pt-2>
      <!-- @authentication-success passes the supplied confirmation UUID to clickProceed -->
      <confirmation-modal @strict-cfr-disabled="clickProceed" @authentication-success="clickProceed" :notesText="notesText">
        <template v-slot:submitAction="{ onSubmit }">
      <button-blue-primary
          type="button"
                           @click="onSubmit"
                           class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:ring-blue-200 sm:text-sm sm:leading-5">
        <slot     name="button-content">
          {{ getSigningButtonText() }}
        </slot>
      </button-blue-primary>
        </template>
      </confirmation-modal>
    </div>
  </div>

</template>

<script>

import axios from "axios";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from "@/mixins/IconNamesMixin";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary";
import ConfirmationModal from "@/components/elements/ConfirmationModal";

export default {
  name: "ReviewConfirmationModal",
  mixins: [SonicuCoreMixin, iconNamesMixin, UrlParamsMixin],
  components: {ConfirmationModal, ButtonBluePrimary},
  emits: ['update:isOpen', 'close', 'action'],
  compatConfig: {
    MODE: 3, // opt-in to Vue 3 behavior for this component only
  },
  props: {
    confirmationEnabled: {
      type: Boolean,
      default: false
    },
    confirmationUuid: null,
    reportHistory: Object,
    selectedReviewType: String,
    reportLink: String
  },
  data() {
    return {
      modalExists: this.isOpen,
      processing: false,
      notesText: '',
      showConfirmationModal: false,
      confirmationAuthenticated: false,
      isOpen: false
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    close() {
      this.$emit('update:isOpen', false);
      // Adding the close event on modal close.
      this.$emit('close');
    },
    clickProceed(confirmationRequestUuid = null){
      this.processing = true;
      console.log('postReview');
        this.postReview(confirmationRequestUuid);
    },
    postReview(confirmationRequestUuid) {
      let data = {'notes': this.notesText}
      console.log('confirmationRequestUuid', confirmationRequestUuid);
      if (this.confirmationEnabled) {
        console.log('confirmation enabled');
        //TODO: If confirmation is enabled, add in confirmationRequestUuid
        data['confirmation_uuid'] = this.confirmationUuid;
        data['confirmation_request_uuid'] = confirmationRequestUuid;
      }
      console.log(data);
      axios.post(this.company.buildCompanyApiInternalRoute(`report-histories/${this.reportHistory.id}/sign/${this.selectedReviewType}`),
          data,
      ).then(response => {
        this.close()
        location.reload();

      }).catch(error => {
        console.log(error)
      });
    },
    clickCancel(){
      this.$emit('action', false);
      this.close();
    },

    getActionText(){
      if(this.selectedReviewType === 'approve'){
        return "Approve Report"
      }
      if(this.selectedReviewType === 'review'){
        return "Review Report"
      }
    },

    getSigningButtonText(){
      if(this.selectedReviewType === 'approve'){
        return "Sign As Approver"
      }
      if(this.selectedReviewType === 'review'){
        return "Sign As Reviewer"
      }
    },
    viewReport(){
      return window.open(this.reportLink, '_blank');
    },
    handleConfirmationAuth(){
      console.log('handleConfirmationAuth');
      this.postReview();
    }

  },
  watch: {

  },
  computed: {

  },
}

</script>

<style scoped>

</style>